import { render } from "./LicenseAgreement.vue?vue&type=template&id=67d0984c&scoped=true"
import script from "./LicenseAgreement.vue?vue&type=script&lang=js"
export * from "./LicenseAgreement.vue?vue&type=script&lang=js"

import "./LicenseAgreement.vue?vue&type=style&index=0&id=67d0984c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67d0984c"]])

export default __exports__